<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <ModalHeader
        title="Edit Position"
        icon="mdi-window-maximize"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          label="Position Name"
          dense
          outlined
          v-model="item.name"
        ></v-text-field>
        <v-textarea
          label="Description"
          dense
          outlined
          v-model="item.description"
        ></v-textarea>
        <v-text-field
          label="Base Rate Per Day"
          dense
          outlined
          v-model="item.base_rate_per_day"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit" :loading="loading">Submit</v-btn>
        <v-btn @click="$emit('close')"> Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">itemProfileModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["item"],
  data() {
    return {
      dialog: true,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      edit_position: "position/edit_position",
    }),
    async submit() {
      // confirm
      let x = await this.$confirm({
        title: "Edit Position",
        message: "Are you sure you want to edit this position?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (!x) return;
      this.loading = true;
      this.edit_position(this.item);
      this.$alert({
        title: "Success",
        message: "Successfully edited a position",
        color: "success",
        icon: "mdi-check-circle",
      });
      this.loading = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
